import { GCP_BUCKET_URL_AVATARS } from "../constants/data";

export const updateDataVenues = (dataVenues) => {
  return dataVenues.map((dataVenue) => {
    const {
      id,
      aquaticCenter,
      building,
      poolName,
      schoolInstitution,
      addressDto,
    } = dataVenue;

    return {
      ...addressDto,
      id,
      aquaticCenter,
      building,
      poolName,
      schoolInstitution,
    };
  });
};

const ensureMaster = (k) => (/_master$/i.test(k) ? k : `${k}_master`);

export const updateDataAds = (dataAds) => {
  return dataAds.map((ad) => {
    const resolvedImageUrl =
      ad.imageUrl ||
      (ad.imageObjectKey
        ? `${GCP_BUCKET_URL_AVATARS}${ensureMaster(
            String(ad.imageObjectKey).replace(/^\/+/, ""),
          )}`
        : null);

    return {
      id: ad.id,
      imageUrl: resolvedImageUrl,
      imageObjectKey: ad.imageObjectKey,
      name: ad.name,
      status: ad.status,
      governingBodies: ad.governingBodies,
      startDate: ad.startDate,
      endDate: ad.endDate,
      creationDate: ad.creationDate,
    };
  });
};


